import { ROUTES } from '../router';

/*
 * Where each platform's "Get" button leads. These are public URLs, so they live
 * here rather than in build configuration.
 *
 * Android is still a Play closed test: a tester has to join the Google Group and
 * opt in before the Play Store will offer the app, so the button leads to the
 * /android walkthrough. Once production access is granted, point `android` at
 * ANDROID_TESTING.store and the walkthrough can go.
 */
export const IOS_TESTFLIGHT_URL = 'https://testflight.apple.com/join/tCwCg8ym';

export const ANDROID_TESTING = {
  group: 'https://groups.google.com/g/tulink-testers/about',
  optIn: 'https://play.google.com/apps/testing/xyz.tulink.app',
  store: 'https://play.google.com/store/apps/details?id=xyz.tulink.app',
};

export const APP_LINKS = {
  ios: IOS_TESTFLIGHT_URL,
  android: ROUTES.android,
};
